import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";

interface IApproveBlackListedMerchantRequest {
    merchantId: string;
}

export function useApproveBlackListedMerchant() {
    return useMutation<BaseResponse<any>, AxiosError, IApproveBlackListedMerchantRequest>(
        async (data) => {
            const response = await axiosInstance.post(
                "/Merchant/ApproveBlackListedMerchant?merchantId=" + data.merchantId,
                {}
            );
            return response.data;
        }
    );
}